import { runtime } from "@codeArt/common";
import { send,on } from "@codeArt/electron/renderer/ipc";
import { map } from "@codeArt/utils/promise";


function open(arg){
    //将arg.url 转换成 从根开始的相对路径
    return send("sys:openWindow",arg);
}

function get(winId){ //获得窗口信息
    winId = winId||runtime.electron.winId;
    return send("sys:getWindowInfo",{winId});
}

function close(winId){
    winId = winId||runtime.electron.winId;
    send("sys:preCloseWindow",{winId});
}

function handleClose(){
    return Promise.all([...handleCloses].map((handle)=> map(handle)));
}

//挂载窗口关闭事件
//由于js都是运行在特定的windows里的，所以这里的handle一定是处理的js所在窗口的事件，不需要通过winId来识别处理器
const handleCloses = new Set();
function onClose(handle){
    handleCloses.add(handle);
}

function offClose(handle){
    handleCloses.delete(handle);
}

(function(){
    if(!runtime.electron) return;
    on("sys:onPreWindowClose.system",({id})=>{
        if(runtime.electron.winId !== id) return; //防止多窗口下冲突
        handleClose().then(()=>{
            send("sys:closeWindow",{winId:id});
        });
    })    
})();

export {open,get,close,onClose,offClose};
